<section class="pricing-section" id="pricing">
  <div class="section-container">
    <div class="section-header">
      <div class="header-badge">
        <span class="badge-icon">💰</span>
        <span class="badge-text">Pricing Plans</span>
      </div>
      <h2 class="section-title">Choose Your Educational Journey</h2>
      <p class="section-subtitle">
        Flexible pricing options designed to make quality education accessible to everyone
      </p>
    </div>
    <div class="pricing-grid">
      <div class="pricing-card" *ngFor="let offer of educationalOffers; let i = index" [class.featured]="offer.featured">
        <div class="pricing-header">
          <h3 class="plan-name">{{ offer.title }}</h3>
          <div class="price-display">
            <span class="currency">{{ offer.currency }}</span>
            <span class="price">{{ offer.price }}</span>
            <span class="period">/{{ offer.period }}</span>
          </div>
        </div>
        <div class="pricing-features">
          <div class="feature-item" *ngFor="let feature of offer.features">
            <span class="feature-check">✓</span>
            <span class="feature-text">{{ feature }}</span>
          </div>
        </div>
        <div class="pricing-footer">
          <button class="pricing-cta" [class.primary]="offer.featured">
            <span class="cta-text">{{ offer.featured ? 'Get Started' : 'Choose Plan' }}</span>
          </button>
        </div>
        <div class="featured-badge" *ngIf="offer.featured">
          <span class="badge-text">Most Popular</span>
        </div>
      </div>
    </div>
  </div>
</section>